export enum ProgressNotification {
  None,
  Saving,
  Saved,
  Error,
}
